import { Text } from "@clipboard-health/ui-components";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib";
import { logEvent } from "@src/appV2/lib/analytics";
import { Button } from "@src/appV2/redesign/components/Button";
import { SHIFT_DISCOVERY_TIER_PATH } from "@src/appV2/redesign/ShiftDiscovery/paths";
import { useShiftModalsDataContext } from "@src/appV2/redesign/ShiftDiscovery/useShiftModalsDataContext";
import { useGetTierType } from "@src/appV2/redesign/Tiers/api/useGetTierType";
import { BaseTierCard } from "@src/appV2/redesign/Tiers/Cards/BaseTierCard";
import { GoldTierCardWrapper } from "@src/appV2/redesign/Tiers/Cards/GoldTierCardWrapper";
import { useHistory } from "react-router-dom";

interface GoldPriorityCardProps {
  count?: number;
}

export function GoldPriorityCard(props: GoldPriorityCardProps) {
  const { count = 0 } = props;
  const { tierType, isTiersEnabled } = useGetTierType();

  const history = useHistory();
  const { baseNavigationPath } = useShiftModalsDataContext();

  if (!isTiersEnabled || count === 0 || tierType !== "GOLD") {
    return null;
  }

  return (
    <GoldTierCardWrapper>
      <BaseTierCard
        title="Book your priority shifts!"
        content={
          <Text variant="body1" textAlign="left">
            Gold members get to book shifts early. Enjoy your head start!
          </Text>
        }
        footer={
          <Button
            invert
            sx={{
              width: "fit-content",
            }}
            onClick={() => {
              logEvent(APP_V2_USER_EVENTS.GOLD_PRIORITY_CARD_EXPLORE_BUTTON_CLICKED);
              history.push(`${baseNavigationPath}/${SHIFT_DISCOVERY_TIER_PATH}`);
            }}
          >
            Explore priority shifts
          </Button>
        }
      />
    </GoldTierCardWrapper>
  );
}
